export class LoginUser {
    email: string;
    password: string;
    token: string;
    usertype: string;
}